import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getService = id => {
  return http.get(
    `${getBaseUrl()}/service/${id}`
  );
};

export const getPersonServices = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/person_service`
    );
  }
  return http.get(
    `${getBaseUrl()}/person_service?${paginate}`
  );
};

export const getAgentServices = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_service`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_service?${paginate}`
  );
};

export const updateService = data => {

  return http.put(
    `${getBaseUrl()}/service/${data.id}`,
    data
  );
};

export const updateServicePriceAndDay = data => {

  return http.put(
    `${getBaseUrl()}/service_price_day/${data.id}`,
    data
  );
};

export const updateServiceStatus = data => {

  return http.put(
    `${getBaseUrl()}/service_status/${data.id}`,
    data
  );
};

export const updateServiceFinish = serviceId => {

  return http.put(
    `${getBaseUrl()}/service_finish/${serviceId}`
  );
};

export const updateServicePayment = data => {

  return http.put(
    `${getBaseUrl()}/service_payment/${data.id}`,
    data
  );
};

export const submitService = data => {

  return http.post(
    `${getBaseUrl()}/person_service`,
    data
  );
};

export const getAgentServiceDocumentation = (service_id) => {

  return http.get(
    `${getBaseUrl()}/agent_service_documentation/${service_id}`,
  );
};

export const submitAgentServiceDocumentation = data => {

  return http.post(
    `${getBaseUrl()}/agent_service_documentation`,
    data
  );
};

export const updateAgentServiceDocumentation = data => {
  return http.put(
    `${getBaseUrl()}/agent_service_documentation/${data.id}`,
    data
  );
};

export const updatePersonServiceDocumentation = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/person_service_documentation`,
    data
  );
};
